import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Mousetrap from 'mousetrap';
import cn from 'classnames';
import Close from '@material-ui/icons/Close';

import Loader from '../General/Loader';

import './Modal.scss';

const Modal = (props) => {
  const { visible, close } = props;
  useEffect(() => {
    if (!visible) return;
    Mousetrap.bind('esc', () => close());
    return () => Mousetrap.unbind('esc');
  }, [visible, close]);

  const stopProp = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div onClick={props.close} className={cn('modal-outer-container', props.className || '', { visible: props.visible })}>
      {props.visible && (
        <div onClick={stopProp} className={cn('modal-container', props.innerClassName || '')}>
          <div className='modal-inner-container'>
            <div className={cn('modal-content', props.contentClassName || '')}>
              {props.title && (
                <div className='modal-header-section'>
                  <h1 className='modal-header'>{props.title}</h1>
                  {props.subtitle && <h2 className='modal-subheader'>{props.subtitle}</h2>}
                </div>
              )}
              {props.children}
            </div>
            {props.showClose && <Close onClick={props.close} className='close-icn' />}
            {props.saving && (
              <div className='loader-container'>
                <Loader size={70} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.any,

  // Optional
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  title: PropTypes.string,
  saving: PropTypes.bool,
  showClose: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {})(Modal);
